import { useMediaQuery } from "@vueuse/core";

export const useIsTouch = () => useMediaQuery("(hover: none)");
